import { createAction } from 'typesafe-actions';
import { takeLatest, put } from 'redux-saga/effects';
import { RELATED_PRODUCT_ITEM_CLICK } from 'features/related-products/ducks';
import { getPrimaryPriceCb, getProductBelongFromSource } from 'features/product-info';

export const sendClickProduct = createAction(
  'GA:clickProduct',
  (data: {
    elementBlock: string;
    productName: string;
    productId: string;
    productPrice: string;
    productPosition: string;
    productBelong: string;
    elementName: string;
  }) => ({
    ...data,
    elementType: 'product',
  }),
)();

export function* runGaClickProductDetector() {
  const gaImpressionsReceivedIds = new Set<string>();

  yield takeLatest(RELATED_PRODUCT_ITEM_CLICK, function* putGaClickProduct({ payload }) {
    const { product } = payload;

    if (!gaImpressionsReceivedIds.has(createSetKey())) {
      gaImpressionsReceivedIds.add(createSetKey());

      yield put(
        sendClickProduct({
          elementBlock: payload.productListId ? payload.productListId : 'productList',
          productName: product.displayedName,
          productId: product.productId,
          productPrice: String(getPrimaryPriceCb(product.price).price),
          productPosition: String(payload.productPositionFromOne),
          productBelong: getProductBelongFromSource(payload.product.source),
          elementName: payload.elementName,
        }),
      );
    }

    function createSetKey() {
      return `${payload.productListId}:${product.productId}`;
    }
  });
}
